// import { createSingleton, createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import axios from 'axios';

// const initialState = {
//   searchResults: [], // { id, name, userType }
//   searchHistory: [], // { user: { id, name, userType }, timestamp } (users current user searched for)
//   reverseSearchHistory: [], // { user: { id, name, userType }, timestamp } (users who searched for current user)
//   selectedUser: null, // { id, name, userType } for basic details
//   premiumDetails: null, // { id, email, phoneNumber, additional fields }
//   loading: false,
//   error: null,
// };

// // Search for a user (employer or seeker)
// export const searchUser = createAsyncThunk(
//   'search/searchUser',
//   async ({ searchTerm, userType }, { rejectWithValue, getState }) => {
//     try {
//       const { user: { currentUser } } = getState();
//       const response = await axios.get(`${process.env.REACT_APP_API_URL}users/search?q=${searchTerm}&userType=${userType}`, {
//         headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
//       });
//       // Log search in backend
//       if (response.data[0]?.id) {
//         await axios.post(`${process.env.REACT_APP_API_URL}users/search-history`, {
//           searcherId: currentUser.uniqueNumber,
//           searchedUserId: response.data[0].id,
//           searcherType: currentUser.userType,
//           searchedUserType: userType,
//           timestamp: new Date().toISOString(),
//         }, {
//           headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
//         });
//       }
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data?.message || 'Search failed');
//     }
//   }
// );

// // Fetch search history (users current user searched for)
// export const fetchSearchHistory = createAsyncThunk(
//   'search/fetchSearchHistory',
//   async (_, { rejectWithValue, getState }) => {
//     try {
//       const { user: { currentUser } } = getState();
//       const response = await axios.get(`${process.env.REACT_APP_API_URL}users/search-history?searcherId=${currentUser.uniqueNumber}`, {
//         headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
//       });
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data?.message || 'Failed to fetch search history');
//     }
//   }
// );

// // Fetch reverse search history (users who searched for current user)
// export const fetchReverseSearchHistory = createAsyncThunk(
//   'search/fetchReverseSearchHistory',
//   async (_, { rejectWithValue, getState }) => {
//     try {
//       const { user: { currentUser } } = getState();
//       const response = await axios.get(`${process.env.REACT_APP_API_URL}users/reverse-search-history?searchedUserId=${currentUser.uniqueNumber}`, {
//         headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
//       });
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data?.message || 'Failed to fetch reverse search history');
//     }
//   }
// );

// // Fetch premium details after payment
// export const fetchPremiumDetails = createAsyncThunk(
//   'search/fetchPremiumDetails',
//   async (userId, { rejectWithValue }) => {
//     try {
//       const response = await axios.get(`${process.env.REACT_APP_API_URL}users/premium-details/${userId}`, {
//         headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
//       });
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data?.message || 'Failed to fetch premium details');
//     }
//   }
// );

// const searchSlice = createSlice({
//   name: 'search',
//   initialState,
//   reducers: {
//     clearSearchResults: (state) => {
//       return { ...state, searchResults: [], premiumDetails: null, selectedUser: null };
//     },
//     setSelectedUser: (state, action) => {
//       return { ...state, selectedUser: action.payload };
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(searchUser.pending, (state) => {
//         return { ...state, loading: true, error: null };
//       })
//       .addCase(searchUser.fulfilled, (state, action) => {
//         return { ...state, loading: false, searchResults: action.payload };
//       })
//       .addCase(searchUser.rejected, (state, action) => {
//         return { ...state, loading: false, error: action.payload };
//       })
//       .addCase(fetchSearchHistory.fulfilled, (state, action) => {
//         return { ...state, searchHistory: action.payload };
//       })
//       .addCase(fetchReverseSearchHistory.fulfilled, (state, action) => {
//         return { ...state, reverseSearchHistory: action.payload };
//       })
//       .addCase(fetchPremiumDetails.fulfilled, (state, action) => {
//         return { ...state, premiumDetails: action.payload };
//       })
//       .addCase(fetchPremiumDetails.rejected, (state, action) => {
//         return { ...state, error: action.payload };
//       });
//   },
// });

// export const { clearSearchResults, setSelectedUser } = searchSlice.actions;
// export default searchSlice.reducer;






import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
  searchResults: [],
  searchHistory: [],
  reverseSearchHistory: [],
  selectedUser: null,
  premiumDetails: null,
  loading: false,
  error: null,
};

export const searchUser = createAsyncThunk(
  'search/searchUser',
  async ({ searchTerm, userType }, { rejectWithValue, getState }) => {
    try {
      const { user: { currentUser } } = getState();
      if (!currentUser?.uniqueNumber) {
        return rejectWithValue('User not authenticated');
      }
      const response = await axios.get(`${process.env.REACT_APP_API_URL}users/search?q=${searchTerm}&userType=${userType}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      if (response.data[0]?.id) {
        await axios.post(`${process.env.REACT_APP_API_URL}users/search-history`, {
          searcherId: currentUser.uniqueNumber,
          searchedUserId: response.data[0].id,
          searcherType: currentUser.userType,
          searchedUserType: userType,
          timestamp: new Date().toISOString(),
        }, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        });
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Search failed');
    }
  }
);

export const fetchSearchHistory = createAsyncThunk(
  'search/fetchSearchHistory',
  async (_, { rejectWithValue, getState }) => {
    try {
      const { user: { currentUser } } = getState();
      if (!currentUser?.uniqueNumber) {
        return rejectWithValue('User not authenticated');
      }
      const response = await axios.get(`${process.env.REACT_APP_API_URL}users/search-history?searcherId=${currentUser.uniqueNumber}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch search history');
    }
  }
);

export const fetchReverseSearchHistory = createAsyncThunk(
  'search/fetchReverseSearchHistory',
  async (_, { rejectWithValue, getState }) => {
    try {
      const { user: { currentUser } } = getState();
      if (!currentUser?.uniqueNumber) {
        return rejectWithValue('User not authenticated');
      }
      const response = await axios.get(`${process.env.REACT_APP_API_URL}users/reverse-search-history?searchedUserId=${currentUser.uniqueNumber}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch reverse search history');
    }
  }
);

export const fetchPremiumDetails = createAsyncThunk(
  'search/fetchPremiumDetails',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}users/premium-details/${userId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch premium details');
    }
  }
);

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    clearSearchResults: (state) => {
      return { ...state, searchResults: [], premiumDetails: null, selectedUser: null };
    },
    setSelectedUser: (state, action) => {
      return { ...state, selectedUser: action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchUser.pending, (state) => {
        return { ...state, loading: true, error: null };
      })
      .addCase(searchUser.fulfilled, (state, action) => {
        return { ...state, loading: false, searchResults: action.payload };
      })
      .addCase(searchUser.rejected, (state, action) => {
        return { ...state, loading: false, error: action.payload };
      })
      .addCase(fetchSearchHistory.fulfilled, (state, action) => {
        return { ...state, searchHistory: action.payload };
      })
      .addCase(fetchSearchHistory.rejected, (state, action) => {
        return { ...state, error: action.payload };
      })
      .addCase(fetchReverseSearchHistory.fulfilled, (state, action) => {
        return { ...state, reverseSearchHistory: action.payload };
      })
      .addCase(fetchReverseSearchHistory.rejected, (state, action) => {
        return { ...state, error: action.payload };
      })
      .addCase(fetchPremiumDetails.fulfilled, (state, action) => {
        return { ...state, premiumDetails: action.payload };
      })
      .addCase(fetchPremiumDetails.rejected, (state, action) => {
        return { ...state, error: action.payload };
      });
  },
});

export const { clearSearchResults, setSelectedUser } = searchSlice.actions;
export default searchSlice.reducer;






















































// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import axios from 'axios';

// const initialState = {
//   searchResults: [],
//   searchHistory: [],
//   reverseSearchHistory: [],
//   selectedUser: null,
//   premiumDetails: null,
//   loading: false,
//   error: null,
//   jobs: [],
// };

// export const createJob = createAsyncThunk(
//   'search/createJob',
//   async (jobData, { rejectWithValue, getState }) => {
//     try {
//       const { user: { currentUser } } = getState();
//       if (!currentUser?._id) {
//         return rejectWithValue('User not authenticated');
//       }
//       const response = await axios.post(`${process.env.REACT_APP_API_URL}jobs`, {
//         ...jobData,
//         employer: currentUser._id,
//       }, {
//         headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
//       });
//       return response.data.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data?.message || 'Failed to create job');
//     }
//   }
// );

// // Existing thunks (fetchSearchHistory, fetchReverseSearchHistory, etc.) remain unchanged
// // ...

// const searchSlice = createSlice({
//   name: 'search',
//   initialState,
//   reducers: {
//     clearSearchResults: (state) => {
//       return { ...state, searchResults: [], premiumDetails: null, selectedUser: null };
//     },
//     setSelectedUser: (state, action) => {
//       return { ...state, selectedUser: action.payload };
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(createJob.pending, (state) => {
//         return { ...state, loading: true, error: null };
//       })
//       .addCase(createJob.fulfilled, (state, action) => {
//         return { ...state, loading: false, jobs: [...state.jobs, action.payload] };
//       })
//       .addCase(createJob.rejected, (state, action) => {
//         return { ...state, loading: false, error: action.payload };
//       });
//     // Existing cases for other thunks...
//   },
// });

// export const { clearSearchResults, setSelectedUser } = searchSlice.actions;
// export default searchSlice.reducer;